/*
 * @Description: 
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2025-03-05 14:57:02
 * @LastEditors: Monkey
 * @LastEditTime: 2025-04-13 23:20:33
 */

// 静态路由配置
// 书写格式与动态路由格式一致，全部经由框架统一转换
// 比较动态路由在meta中多加入了role角色权限，为数组类型。一个菜单是否有权限显示，取决于它以及后代菜单是否有权限。
// routes 显示在左侧菜单中的路由(显示顺序在动态路由之前)
// 示例如下


// 用户静态路由，用户登录后加入
const routes = [
  {
    name: 'defaultpassword',
    path: "/default_password",
    component: 'login/defaultPassword',
    meta: {
      title: "修改默认密码",
      hidden: true,
      fullpage: true
    }
  },
  // {
  //   name: "demo",
  //   path: "/test",
  //   meta: {
  //     icon: "el-icon-eleme-filled",
  //     title: "演示",
  //   },
  //   children: [{
  //     name: "demopage",
  //     path: "/test/page",
  //     component: "userCenter/test",
  //     meta: {
  //       icon: "el-icon-menu",
  //       title: "演示页面",
  //     }
  //   }, {
  //     name: "demopage2",
  //     path: "/test/page2",
  //     component: "userCenter/test2",
  //     meta: {
  //       icon: "el-icon-menu",
  //       title: "演示页面2",
  //     }
  //   }]
  // }
]

export default routes;
